export default "__VITE_ASSET__CIl2e63S__"